import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../apiBase";
import { ownerSecretHeader } from "../ownerSecret";

export const EditRollPage = ({ rollToEdit, currentAircraft }) => {
  const navigate = useNavigate();

  const rowId = rollToEdit?.id ?? "";
  const tail = currentAircraft?.tailNumber || "";

  const [sea, setSea] = useState(
  String(rollToEdit?.Sea_Level ?? rollToEdit?.Sea_level ?? "")
);
  const [msl2500, setMsl2500] = useState(
  String(
    rollToEdit?.Field_Elevation ??
    rollToEdit?.field_elevation ??
    rollToEdit?.["2500MSL"] ??     // fallback for existing docs
    ""
  )
);
  const [units, setUnits] = useState(String(rollToEdit?.units ?? "Feet"));

  const save = async () => {
    if (!rowId) {
      alert("Missing rollout id");
      return;
    }

    if (!tail) {
      alert("Missing aircraft tail");
      return;
    }

    // Normalize to ONE sea-level key on write (pick Sea_Level)
    const edited = {
      id: rowId,
      Sea_Level: Number(sea),
      Field_Elevation: Number(msl2500),
      units: String(units || "Feet"),
    };
    /**
     * Ids must be URL-encoded because they may contain special characters
     * such as spaces or slashes.
     */
    const url = `${API_BASE}/api/rollouts?tail=${encodeURIComponent(tail)}&id=${encodeURIComponent(rowId)}`;
    const res = await fetch(
      url,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...ownerSecretHeader(tail),
        },
        body: JSON.stringify(edited),
      }
    );

    if (res.ok) {
      alert("Successfully edited rollout");
      navigate("/rollout"); // goes back to rollout page
    } else if (res.status === 403) {
      alert("You're not authorized to edit this aircraft's rollout data.");
    } else {
      alert(`Failed to edit rollout, status ${res.status}: ${await res.text()}`);
    }
  };

  return (
    <div>
      <p>Edit Rollout</p>

      <table id="edit-roll">
        <thead>
          <tr>
            <th className="type_box">Row</th>
            <th className="sea_box">Sea Level</th>
            <th className="msl_box">Field Elevation</th>
            <th className="unit_box">Units</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td className="type_box">{rowId}</td>

            <td className="sea_box">
              <input type="text" value={sea} onChange={(e) => setSea(e.target.value)} />
            </td>

            <td className="msl_box">
              <input type="text" value={msl2500} onChange={(e) => setMsl2500(e.target.value)} />
            </td>

            <td className="unit_box">
              <select value={units} onChange={(e) => setUnits(e.target.value)}>
                <option>Feet</option>
                <option>ft</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>

      <button onClick={save}>Save</button>
      <button onClick={() => navigate("/rollout")}>Cancel</button>
    </div>
  );
};

export default EditRollPage;